import { useDriverContext } from '@/contexts/DriverContext';

export const useDriver = useDriverContext;

export type {
  DriverTourDefinition,
  DriverStartOptions,
} from '@/contexts/DriverContext';
